
import React, { useState } from "react";
import { ChevronLeft, ChevronRight, FileText, ClipboardList } from "lucide-react";
import { Button } from "@/components/ui/button";

interface TherapeuticSidebarProps {
  onAction: (action: 'transcript' | 'notes') => void;
  activeView: 'transcript' | 'notes' | null;
}

const TherapeuticSidebar: React.FC<TherapeuticSidebarProps> = ({ onAction, activeView }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const therapeuticSections = [
    { 
      id: "transcript", 
      title: "Session Transcript", 
      action: 'transcript' as const,
      icon: FileText
    },
    { 
      id: "notes", 
      title: "Session Notes", 
      action: 'notes' as const,
      icon: ClipboardList
    },
  ];

  return (
    <div className={`bg-white border-r lg:border-r border-b lg:border-b-0 transition-all duration-300 ${isCollapsed ? 'w-16' : 'w-full lg:w-80'}`}>
      <div className="p-3 md:p-4 border-b flex items-center justify-between">
        {!isCollapsed && (
          <h3 className="text-lg md:text-xl font-bold">Psybytes Copilot</h3>
        )}
        {/* <Button
          variant="ghost"
          size="icon"
          onClick={() => setIsCollapsed(!isCollapsed)}
          className="shrink-0"
        >
          {isCollapsed ? <ChevronRight className="h-4 w-4" /> : <ChevronLeft className="h-4 w-4" />}
        </Button> */}
      </div>
      
      {!isCollapsed && (
        <div className="p-4 md:p-6 overflow-y-auto">
          <p className="text-gray-700 mb-4 md:mb-6 text-sm md:text-base">
            Psybytes Copilot offers insights on key therapeutic factors to
            enhance client engagement and your approach.
          </p>
          
          <div className="space-y-3 md:space-y-4">
            {therapeuticSections.map((section) => {
              const isActive = activeView === section.action;
              const IconComponent = section.icon;
              
              return (
                <div key={section.id} className="border-b pb-3 md:pb-4">
                  <button
                    onClick={() => onAction(section.action)}
                    className={`flex items-center justify-between w-full p-3 rounded transition-colors touch-target ${
                      isActive 
                        ? 'bg-blue-50 border-l-4 border-l-blue-500' 
                        : 'hover:bg-gray-50'
                    }`}
                  >
                    <div className="flex items-center">
                      <div className={`w-7 h-7 md:w-8 md:h-8 rounded-full flex items-center justify-center mr-3 ${
                        isActive ? 'bg-blue-100' : 'bg-green-100'
                      }`}>
                        <IconComponent className={`w-3.5 h-3.5 md:w-4 md:h-4 ${
                          isActive ? 'text-blue-600' : 'text-green-600'
                        }`} />
                      </div>
                      <h4 className={`font-semibold text-left text-sm md:text-base ${
                        isActive ? 'text-blue-700' : 'text-gray-700'
                      }`}>
                        {section.title}
                      </h4>
                    </div>
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default TherapeuticSidebar;
